// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-icon {\n  width: 50px;\n}\n\n.gv-links {\n  color: #60a5fa;\n  text-decoration: none;\n}\n\n.gv-links:hover {\n  color: #FFFFFF;\n}", "",{"version":3,"sources":["webpack://./client/css/home.css"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
